import { render } from "./CampaignsDashboard.vue?vue&type=template&id=aef4559e&scoped=true"
import script from "./CampaignsDashboard.vue?vue&type=script&lang=js"
export * from "./CampaignsDashboard.vue?vue&type=script&lang=js"

import "./CampaignsDashboard.vue?vue&type=style&index=0&id=aef4559e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef4559e"]])

export default __exports__